import { useEffect, useState } from 'react';
import { Spinner } from '@blueprintjs/core';
import { Redirect } from 'react-router-dom';
import { errorToast } from '../../utils/toaster';
import { getAuthPkgUser, initAuthPkgUser } from '../../services/auth-pkg-user';
import { authPkgConfig } from '@auravisionlabs/aura-pkg-auth-service';

const RequireDashboardReportRead = ({ children }) => {
  const [allowed, setAllowed] = useState(null);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        let authUser = getAuthPkgUser();
        if (!authUser) {
          authUser = await initAuthPkgUser();
        }
        if (!authUser) {
          if (mounted) setAllowed(false);
          return;
        }
        const orgId = await authUser.getPrimaryOrgId();
        const canRead = await authUser
          .can(
            authPkgConfig.resources.dashboardReport,
            authPkgConfig.authActions.read,
            { orgIds: [orgId] }
          )
          .evaluate();
        if (mounted) setAllowed(!!canRead);
      } catch (e) {
        if (mounted) setAllowed(false);
      }
    })();
    return () => {
      mounted = false;
    };
  }, []);

  if (allowed === null) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem' }}>
        <Spinner size={24} />
      </div>
    );
  }

  if (allowed === false) {
    errorToast({ message: 'You do not have access to view reports.' });
    return <Redirect to="/" />;
  }

  return children;
};

export default RequireDashboardReportRead;
